"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentGsiAccountIdCategoryPk = exports.getFxGsiAccountIdCategoryPk = exports.getIatGsiAccountIdCategoryPk = exports.getGsiAccountIdCategoryPk = void 0;
const getGsiAccountIdCategoryPk = (accountId, iatId, clientFxTradeId, paymentId) => {
    if (iatId) {
        return (0, exports.getIatGsiAccountIdCategoryPk)(accountId, iatId);
    }
    if (clientFxTradeId) {
        return (0, exports.getFxGsiAccountIdCategoryPk)(accountId, clientFxTradeId);
    }
    if (paymentId) {
        return (0, exports.getPaymentGsiAccountIdCategoryPk)(accountId, paymentId);
    }
    return undefined;
};
exports.getGsiAccountIdCategoryPk = getGsiAccountIdCategoryPk;
const getIatGsiAccountIdCategoryPk = (accountId, iatId) => {
    return `${accountId}#IAT#${iatId}`;
};
exports.getIatGsiAccountIdCategoryPk = getIatGsiAccountIdCategoryPk;
const getFxGsiAccountIdCategoryPk = (accountId, clientFxTradeId) => {
    return `${accountId}#FX#${clientFxTradeId}`;
};
exports.getFxGsiAccountIdCategoryPk = getFxGsiAccountIdCategoryPk;
const getPaymentGsiAccountIdCategoryPk = (accountId, paymentId) => {
    return `${accountId}#PAYMENT#${paymentId}`;
};
exports.getPaymentGsiAccountIdCategoryPk = getPaymentGsiAccountIdCategoryPk;
